import { render, staticRenderFns } from "./ResponsaveisInlineForm.vue?vue&type=template&id=98c924d0&scoped=true&"
import script from "./ResponsaveisInlineForm.vue?vue&type=script&lang=js&"
export * from "./ResponsaveisInlineForm.vue?vue&type=script&lang=js&"
import style0 from "./ResponsaveisInlineForm.vue?vue&type=style&index=0&id=98c924d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c924d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VIcon,VRow,VTextField})
